import { IBasket } from "@/entities";
import { IOrder, Order } from "@/entities/order/order";
import { IDraftOrderRepository } from "@/repositories/draftOrder";
import { IOrderRepository } from "@/repositories/order/order.types";
import { IDraftOrderService } from ".";

// export const defaultBasket: IBasket = new Basket({
//     basketId: "",
//     basketName: "",
//     ownerId: "",
//     productList: [],
//     branchId: "any"
// }); 

export class DraftOrderService implements IDraftOrderService {
    constructor(private repository: IDraftOrderRepository) {}

    async getDraftOrderById(id: string): Promise<IOrder | undefined> {
        return (await this.repository.get(id));
    }

    async createDraftOrder(data: IOrder): Promise<IOrder> {
        return (await this.repository.create(data));
    }

    async sync(data: IOrder): Promise<IOrder> {
        const draftOrder = await this.getDraftOrderById(data.ownerId!);
        if(draftOrder){
            return draftOrder;
        }
        return this.createDraftOrder(data);
    }

    async update(data: IOrder): Promise<IOrder> {
        return this.repository.update(data);
    }

    // async syncBasket(basketData: IBasketData, apikey: string): Promise<IBasket> {
    //     const user = await this.getBasketById(basketData.basketId!, basketData.ownerId, apikey);
    //     if(user){
    //         return user;
    //     }
    //     return await this.createBasket(basketData, apikey);
    // }
}
